(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('LoginInitializationServiceJs', [
        '$log',
        '$q',
        'AprimaAnalytics',
        'Bridge',
        'aprgettext',
        'LocalStorageRepository',
        'LoginInitializationService',
        'LogInService',
        'LogOffService',
        'ServerInfoRepository',
        'SettingService',
        'TransitionManager',
        'VersionService',
        LoginInitializationServiceJs,
    ]);

    function LoginInitializationServiceJs(
        $log,
        $q,
        AprimaAnalytics,
        Bridge,
        gettext,
        LocalStorageRepository,
        LoginInitializationService,
        LogInService,
        LogOffService,
        ServerInfoRepository,
        SettingService,
        TransitionManager,
        VersionService
    ) {
        function preLogin(clientServerInfo, clientId, username) {
            var oldClientId = LocalStorageRepository.getClientID(),
                oldUsername = LocalStorageRepository.getUserName(),
                isNew = false;

            if (oldClientId !== clientId || oldUsername !== username) {
                LocalStorageRepository.clearAll();
                LogInService.setDefaultRedirect();

                isNew = true;
            }

            LogOffService.logoff();
            LocalStorageRepository.setClientURL(clientServerInfo.registeredServerInfo.AppServerUrl);
            LocalStorageRepository.setGatewayUrl(clientServerInfo.gatewayConfiguration.url);
            LocalStorageRepository.setClientID(clientId);
            LocalStorageRepository.setUserName(username);

            return isNew;
        }

        function updateVersionInfo(userLoginInfo) {
            if (userLoginInfo) {
                if(userLoginInfo.ProductVersions){
                    if (userLoginInfo.ProductVersions.PrmAssemblyVersion) {
                        ServerInfoRepository.setPrmAssemblyVersion(userLoginInfo.ProductVersions.PrmAssemblyVersion);
                    }
                    if (userLoginInfo.ProductVersions.PrmDatabaseVersion) {
                        ServerInfoRepository.setPrmDatabaseVersion(userLoginInfo.ProductVersions.PrmDatabaseVersion);
                    }
                    if (userLoginInfo.ProductVersions.PrmDatabaseBuild) {
                        ServerInfoRepository.setPrmDatabaseBuild(userLoginInfo.ProductVersions.PrmDatabaseBuild);
                    }
                    if (userLoginInfo.ProductVersions.AppServiceVersion) {
                        ServerInfoRepository.setMobileAssemblyVersion(userLoginInfo.ProductVersions.AppServiceVersion);
                    }
                    if(userLoginInfo.SupportedFeatures){
                        ServerInfoRepository.setSupportedFeatures(userLoginInfo.SupportedFeatures);
                    }
                }

                if(userLoginInfo.DatabaseName){
                    ServerInfoRepository.setDatabaseName(userLoginInfo.DatabaseName);
                }
            }
        }

        function haveVersionsChanged(userLoginInfo) {
            if (userLoginInfo && userLoginInfo.ProductVersions) {
                return  ( LocalStorageRepository.getApplicationVersion() !== VersionService.getClientVersion() ||
                userLoginInfo.ProductVersions.PrmAssemblyVersion !== ServerInfoRepository.getPrmAssemblyVersion() ||
                userLoginInfo.ProductVersions.PrmDatabaseVersion !== ServerInfoRepository.getPrmDatabaseVersion() ||
                userLoginInfo.ProductVersions.PrmDatabaseBuild !== ServerInfoRepository.getPrmDatabaseBuild() ||
                userLoginInfo.ProductVersions.AppServiceVersion !== ServerInfoRepository.getMobileAssemblyVersion());
            }
            else{
                return true;
            }
        }

        function initializeFromPrmLogin(userLoginInfo) {
            var authToken = userLoginInfo.JsonWebToken,
                clientURL = LocalStorageRepository.getClientURL(),
                msg;

            return VersionService.checkVersions(userLoginInfo.SupportedApiVersions, userLoginInfo.MinClientVersion).then(function (validationSuccesful) {
                if (validationSuccesful === false) {
                    return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                }

                if (!userLoginInfo) {
                    msg = gettext('Unexpected null result from server in Login');
                }
                else if (!userLoginInfo.DeviceId) {
                    return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
                }

                if (msg) {
                    $log.warn(msg);
                    AprimaAnalytics.sendException(msg);
                }

                LoginInitializationService.initializeFromPrmLogin(userLoginInfo);
                LocalStorageRepository.clearKeysOfType('metadata');

                LocalStorageRepository.setDeviceId(userLoginInfo.DeviceId);
                LocalStorageRepository.setJsonWebToken(authToken);
                LocalStorageRepository.setUserID(userLoginInfo.Id);
                LocalStorageRepository.setUserPermissions(userLoginInfo.Permissions || {});
                if(haveVersionsChanged(userLoginInfo)){
                    LocalStorageRepository.clearOldVersionCache();
                    LocalStorageRepository.setApplicationVersion(VersionService.getClientVersion());
                }

                updateVersionInfo(userLoginInfo);

                Bridge.changeUserInfo(authToken, clientURL, userLoginInfo.Id);

                return SettingService.loadSettings().catch(function () {
                    return $q.reject(new Error(gettext('Error loading settings.')));
                });
            }, function () {
                return $q.reject(new Error(gettext('Client Version not compatible with api server. Please update your app.')));
            });
        }

        function finishPrmLogin() {
            TransitionManager.transition(LogInService.getRedirect());
            LogInService.setDefaultRedirect();
        }

        return {
            initializeFromPrmLogin: initializeFromPrmLogin,
            preLogin: preLogin,
            finishPrmLogin: finishPrmLogin,
        };
    }
})(window.angular);
